<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Benutzer bearbeiten</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form name="userform" @submit.prevent="save" v-model="formValid">
              <v-container>
                <v-row>
                  <v-col>
                    <v-switch
                      v-model="user.active"
                      label="Benutzer aktiv"
                      color="success"
                    >
                    </v-switch>
                  </v-col>
                  <v-col>
                    <v-switch
                      v-if="!user._id"
                      @change="
                        user.sendActivationLink ? (user.password = '') : null
                      "
                      v-model="user.sendActivationLink"
                      label="Aktivierungslink senden"
                      color="success"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Vorname"
                      name="firstname"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.firstname"
                      required
                      :rules="requiredRule"
                    />
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Nachname"
                      name="lastname"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.lastname"
                      required
                      :rules="requiredRule"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Email"
                      name="email"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.email"
                      required
                      :rules="emailRules"
                    />
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Telefon"
                      name="telefon"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.telefon"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12">
                    <v-text-field
                      :disabled="user.sendActivationLink"
                      label="Passwort"
                      name="password"
                      :type="passwordVisible"
                      color="purple"
                      v-model="user.password"
                      v-bind:required="
                        user._id == null && !user.sendActivationLink
                          ? 'required'
                          : ''
                      "
                      :rules="
                        user._id == null && !user.sendActivationLink
                          ? requiredRule
                          : []
                      "
                      :append-icon="passwordIcon"
                      @click:append="showPassword"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="6">
                    <CustomerSelectbox
                      v-model="customer"
                      :disabled="
                        user.role == 'superuser' || user.role == 'manager'
                      "
                      v-bind:required="
                        user.role != 'superuser' && user.role != 'manager'
                          ? 'required'
                          : []
                      "
                    />
                  </v-col>
                  <v-col sm="6">
                    <v-select
                      label="Rolle"
                      name="role"
                      :items="roleItems"
                      color="purple"
                      :clearable="true"
                      v-model="user.role"
                      v-bind:required="
                        user.role != 'superuser' ? 'required' : ''
                      "
                      :disabled="user.role == 'superuser'"
                      :rules="user.role == 'superuser' ? requiredRule : []"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="customer && customer.restekarte">
                    <v-switch
                      color="green"
                      v-model="user.showRestekarte"
                      label="Restekarte anzeigen"
                      persistent-hint
                      hint="Zeigt die Gerichte nach Lieferorte an, die in der
                        Abteilung des Benutzers noch verfügbar sind."
                    />
                  </v-col>
                  <v-col>
                    <v-switch
                      v-if="isCustomerAdmin"
                      color="green"
                      v-model="user.canOrderGrossbestellung"
                      label="Darf Großbestellungen bestellen"
                      persistent-hint
                      hint="Kann für alle Gerichte eine Großbestellung für die Firma durchführen"
                    />
                  </v-col>
                </v-row>

                <v-divider class="mt-8" />
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :to="{ path: '/user' }"
              color="error"
              type="button"
              name="cancel"
              >Abbrechen</v-btn
            >
            <v-spacer />
            <v-btn
              @click="save"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService.js";
import CustomerSelectbox from "@/components/customers/CustomerSelectbox";

export default {
  name: "UserForm",
  components: { CustomerSelectbox },
  props: [],
  data: () => ({
    passwordVisible: "password",
    passwordIcon: "mdi-eye-outline",
    customer: null,
    user: {
      customerId: null,
      firstname: "",
      lastname: "",
      telefon: "",
      email: "",
      password: "",
      _id: null,
      active: true,
      role: "",
      canOrderGrossgebinde: false,
      canOrderGrossbestellung: false,
      sendActivationLink: false,
    },

    roleItems: [
      { text: "System Admin", value: "manager" },
      { text: "Kunden Admin", value: "customer-admin" },
      { text: "Kunden User", value: "customer" },
    ],
    requiredRule: [(value) => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      (v) => !!v || "E-mail wird benötigt!",
      (v) =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail nicht gültig",
    ],
    formValid: false,
  }),
  computed: {
    isCustomerAdmin() {
      return (
        this.user.role ===
        this.$store.getters["user/userRoles"].userRole.CustomerAdmin
      );
    },
  },
  methods: {
    showPassword() {
      if (this.passwordVisible === "password") {
        this.passwordVisible = "text";
        this.passwordIcon = "mdi-eye-off-outline";
      } else {
        this.passwordVisible = "password";
        this.passwordIcon = "mdi-eye-outline";
      }
    },
    checkAccess(role) {
      if (!this.user) {
        return false;
      }
      if (
        this.user.role ===
        this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (this.user.role === role) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      this.user.customerId =
        this.user.role === "manager" || this.user.role === "superuser"
          ? "system"
          : this.customer._id;

      if (
        (this.customer && !this.customer.grossgebinde) ||
        (this.customer && this.customer.grossgebinde && !this.isCustomerAdmin)
      ) {
        this.user.canOrderGrossgebinde = false;
      }

      UserService.saveUser({
        id: this.user._id,
        data: this.user,
      })
        .then(() => {
          //if success redirect to list
          this.$router.push({ name: "user" });
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Benutzer gespeichert",
            text: "Benutzer erfolgreich gespeichert",
          });
        })
        .catch((error) => {
          //on error alert error
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message,
          });
        });
    },
  },
  created() {
    const id = this.$route.params.id;

    if (id) {
      UserService.fetch(id)
        .then(async (result) => {
          this.user = result.data.data;
          this.user.password = "";

          let customers = this.$store.getters["customer/getCustomerList"];

          if (customers && customers.length == 0) {
            try {
              customers = await this.$store.dispatch(
                "customer/fetchCustomerList"
              );
            } catch (error) {
              Promise.reject(new Error("Error loading customers"));
            }
          }

          this.customer = customers.find(
            (el) => el._id === this.user.customerId
          );

          /* if (this.user.customerId && this.user.customerId !== "system") {
            this.$store
              .dispatch("customer/fetchCustomer", this.user.customerId)
              .then((result) => {
                if (result.data.data) {
                  //  console.log("result", result.data.data);
                  this.customer = result.data.data;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }*/
        })

        .catch((error) => {
          console.log(error);
          if (error && error.response && error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    }
  },
};
</script>

<style scoped></style>
